import React from 'react';
import { useTranslation } from 'react-i18next';
import PreviewTitle from '../../previewTitle/previewTitle';

const SuBusinessAccountPreview = () => {
	const { t } = useTranslation();

	return (
		<div data-testid="su-business-account-preview">
			<PreviewTitle size="two">{t('payment_method.su_business_account.label')}</PreviewTitle>
		</div>
	);
};

export default SuBusinessAccountPreview;
